import { Spinner } from '@components/Spinner';
import { useAuth } from '@hooks/useAuth';
import { environment } from '@lib/environment';
import { createInstance, OptimizelyProvider } from '@optimizely/react-sdk';
import React, { useEffect, useState } from 'react';
import * as styled from './App.styled';

const optimizelyClient = createInstance({
    sdkKey: environment.REACT_APP_OPTIMIZELY_KEY(),
});

export const OptimizelyWrapper: React.FC = ({ children }) => {
    const auth = useAuth();
    const [userID, setUserID] = useState('');
    const [email, setEmail] = useState('');
    const [timedOut, setTimedOut] = useState(false);

    useEffect(() => {
        if (auth) {
            setUserID(auth.sub);
            setEmail(auth.email);
            return;
        }

        const timeout = setTimeout(() => {
            setTimedOut(true);
        }, 5000);

        analytics.ready(() => {
            if (!timedOut) {
                const anonymousID = analytics.user().anonymousId();
                setUserID(anonymousID);
                clearTimeout(timeout);
            }
        });

        return () => {
            clearTimeout(timeout);
        };
    }, [auth]);

    if (!userID && !timedOut) {
        return (
            <styled.Spinner>
                <Spinner />
            </styled.Spinner>
        );
    }

    return (
        <OptimizelyProvider
            optimizely={optimizelyClient}
            user={{
                id: userID || null,
                attributes: {
                    email,
                },
            }}
        >
            {children}
        </OptimizelyProvider>
    );
};
